import { useMemo } from "react";
import { useIsClient } from "@bitcart/hooks";
// src/hooks/css-runtime.ts
const useCssRuntimeFeatureSupport = ({ property, value }) => {
	const isClient = useIsClient();
	return useMemo(() => isClient ? CSS.supports(property, value) : false, [
		isClient,
		property,
		value
	]);
};
export { useCssRuntimeFeatureSupport };

//# sourceMappingURL=css-runtime.js.map